import { render } from "./PlaceholderPanel.vue?vue&type=template&id=e0fccb2a&scoped=true"
import script from "./PlaceholderPanel.vue?vue&type=script&lang=js"
export * from "./PlaceholderPanel.vue?vue&type=script&lang=js"

import "./PlaceholderPanel.vue?vue&type=style&index=0&id=e0fccb2a&lang=scss&scoped=true"
import "./PlaceholderPanel.vue?vue&type=style&index=1&id=e0fccb2a&lang=scss"
script.render = render
script.__scopeId = "data-v-e0fccb2a"

export default script